import {styled} from '@mui/material'
import {Texts} from 'appearance'

const SubscriptionItem = ({title, value, valueSuffix, boldValue}) => {
    const text = [value, valueSuffix]
        .filter((value) => value !== undefined)
        .join(' ')

    return (
        <Container>
            <Title>{title}</Title>
            <Value bold={boldValue}>{text}</Value>
        </Container>
    )
}

export default SubscriptionItem

const Container = styled('div')`
    display: flex;
    flex-direction: column;
`

const Title = styled(Texts.BoldText)``

const Value = styled(Texts.RegularText)`
    font-weight: ${({bold}) => (bold ? 'bold' : '300')};
`
